import React from "react";
import { Link } from "react-router-dom";
import { BedDouble, Ruler, MapPin, Zap } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const eur = (n) => new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);

export default function PropertyCard({ p, matchScore }) {
  const { t } = useI18n();
  const primary = p.photos?.find((x) => x.is_primary) || p.photos?.[0];
  const img = primary?.data_url || primary?.url || "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85";
  return (
    <Link
      to={`/woning/${p.id}`}
      className="wv-card block"
      data-testid={`property-card-${p.id}`}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img src={img} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" loading="lazy" />
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="wv-badge-verified" data-testid="property-verified-badge">{t("prop.verified")}</span>
          {matchScore != null && <span className="wv-badge-match" data-testid="property-match-badge">{matchScore}{t("prop.match_suffix")}</span>}
        </div>
        {p.energy_label && (
          <span className="absolute bottom-3 right-3 bg-white/95 backdrop-blur px-2 py-1 rounded-md text-[11px] font-bold font-mono-num text-[color:var(--wv-green-dark)] flex items-center gap-1">
            <Zap className="w-3 h-3" /> {p.energy_label}
          </span>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-baseline justify-between gap-3">
          <p className="font-mono-num text-lg font-bold text-[color:var(--wv-navy)]" data-testid="property-price">{eur(p.price)}</p>
          <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold">{p.property_type}</p>
        </div>
        <h3 className="mt-1 font-display font-bold text-lg text-slate-900 leading-tight line-clamp-2" data-testid="property-title">{p.title}</h3>
        <div className="mt-2 flex items-center gap-1 text-sm text-slate-500">
          <MapPin className="w-3.5 h-3.5" />
          <span>{p.city}</span>
        </div>
        <div className="mt-4 pt-4 border-t border-slate-100 flex items-center gap-4 text-sm text-slate-600">
          <span className="flex items-center gap-1.5"><BedDouble className="w-4 h-4" /><span className="font-mono-num">{p.bedrooms}</span> {t("prop.slk")}</span>
          <span className="flex items-center gap-1.5"><Ruler className="w-4 h-4" /><span className="font-mono-num">{p.area_m2}</span> {t("prop.m2")}</span>
        </div>
      </div>
    </Link>
  );
}
